import { Box, Tooltip } from "@mui/material"
import type { Cell, Row } from "@tanstack/react-table"
import { flexRender } from "@tanstack/react-table"
import React from "react"

import type { Company } from "@/graphql/codegen/graphql"

interface SupplierReportRowProps {
  row: Row<Company>
  isExpanded: boolean
  getFlexibleColumnWidth: (cell: any) => string
  children?: React.ReactNode
}

export const SupplierReportProductTableRow: React.FC<SupplierReportRowProps> = ({
  row,
  isExpanded,
  getFlexibleColumnWidth,
  children,
}) => {
  return (
    <Box className='flex w-full flex-col'>
      <Box
        className={`grid items-center border border-t-0 border-gray-300 tracking-[0.011rem] text-gray-700 ${isExpanded ? "bg-primary-100" : "bg-white"}`}
        style={{
          gridTemplateColumns: row
            .getVisibleCells()
            .map((cell) => getFlexibleColumnWidth({ column: cell.column }))
            .join(" "),
        }}
      >
        {row.getVisibleCells().map((cell: Cell<Company, unknown>) =>
          cell.column.id === "status" ? (
            <Box key={cell.id} className='flex w-full items-center justify-center px-4 py-3'>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </Box>
          ) : (
            <Box key={cell.id} className='flex w-full items-center overflow-hidden px-4 py-3'>
              <Tooltip title={cell.getValue() as string} enterDelay={1000}>
                <Box className='w-full truncate'>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Box>
              </Tooltip>
            </Box>
          )
        )}
      </Box>
      {isExpanded && <Box className='overflow-hidden border border-t-0 border-gray-300 bg-white p-6'>{children}</Box>}
    </Box>
  )
}
